export const ADE_DATA_START_YYYYMM = "202001";
export const ADE_DEFAULT_JOB_RATE_REQ_PER_MIN = 8;
export const ADE_SOFT_LIMIT_REQ_PER_MIN = 10;
export const ADE_JOB_RATE_MIN = 2;
export const ADE_JOB_RATE_MAX = 10;
export const ADE_REQS_PER_ZONE_YEAR = 2;
export const ADE_ESTIMATE_YEARS_FULL = 10;

export function aggregateAdeSoftLimitReqPerMin(liveSessions: number): number {
  return Math.max(1, liveSessions) * ADE_SOFT_LIMIT_REQ_PER_MIN;
}
